import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Select } from 'antd';
import './userProfileItem.scss';
import { EMPTY_OBJECT, EMPTY_STRING, NO_OP } from '../../constants/Constants';
export const UserProfileItem = props => {
  const {
    label,
    value,
    canEdit,
    onClickEdit,
    onChange,
    isEditMode,
    inputType = 'Input',
    inputProps,
    showWarning
  } = props;
  const renderValueField = () => {
    if (isEditMode) {
      if (inputType === 'Select') {
        return /*#__PURE__*/React.createElement(Select, {
          className: "update-language-dropdown",
          defaultValue: inputProps.defaultValue,
          onChange: onChange,
          size: inputProps.size
        }, inputProps.options.map(opt => /*#__PURE__*/React.createElement(Select.Option, {
          key: opt.value,
          value: opt.value
        }, opt.label, " ")));
      }
      return /*#__PURE__*/React.createElement(Input, {
        value: value,
        type: "number",
        className: "update-user-contact ".concat(showWarning ? 'error' : ''),
        onChange: onChange
      });
    }
    return /*#__PURE__*/React.createElement("h4", {
      className: "userprofile-value"
    }, value);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "userprofile-Item"
  }, /*#__PURE__*/React.createElement("label", {
    className: "userprofile-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "userprofile-value-field"
  }, renderValueField(), " ", canEdit && /*#__PURE__*/React.createElement(Button, {
    className: "update-user-details-icon",
    onClick: onClickEdit,
    hidden: isEditMode
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-edit"
  }))));
};
UserProfileItem.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  canEdit: PropTypes.bool,
  onClickEdit: PropTypes.func,
  onChange: PropTypes.func,
  isEditMode: PropTypes.bool,
  inputType: PropTypes.string,
  inputProps: PropTypes.object
};
UserProfileItem.defaultProps = {
  label: EMPTY_STRING,
  value: EMPTY_STRING,
  canEdit: false,
  onClickEdit: NO_OP,
  onChange: NO_OP,
  isEditMode: false,
  inputType: EMPTY_STRING,
  inputProps: EMPTY_OBJECT
};